import util from '../util'

let controller = 'CadastroRestritivo'

export default Object.assign({}, util.GetCrud(controller, null), { 
    Importar: function (dto) {
      return util.Axios.Post(controller + '/ImportarArquivo', dto)
    },
    GetHistorico: function (dto) {
      return util.Axios.GetAll(controller + `/Historico`, dto)
    },
    ValidarImportacao: function (dto) {
      return util.Axios.Post(`${controller}/ValidarImportacao`, dto)
    },
    GetSaldos: function(documentoFederal) {
      return util.Axios.GetAll(`${controller}/GetSaldos/${documentoFederal}`)
    },
    GetBoletos: function(documentoFederal) {
      return util.Axios.GetAll(`${controller}/GetBoletos/${documentoFederal}`)
    },
    GetSplit: function(documentoFederal) {
      return util.Axios.GetAll(`${controller}/GetSplit/${documentoFederal}`)
    },
    GetByDocumentoFederal: function(documentoFederal) {
      return util.Axios.Get(`${controller}/GetByDocumentoFederal/${documentoFederal}`)
    },
    ValidaDocumentoFederalCadastroRestritivo: function(documentoFederal) {
      return util.Axios.Get(`${controller}/ValidaDocumentoFederalCadastroRestritivo/${documentoFederal}`)
    },
    GetByConta: function (dto,options) {
      return util.Axios.GetAll(controller + '/GetByConta', dto)
    },
    ObterRelatorioExcel: function (dto, options) {
      return util.Axios.GetBlob(controller + '/Relatorio', dto)
    },
})

